import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RestApiService } from '../services/api/rest-api.service';
import {
  ET0Model,
  LanguagesDataModel,
  LayoutDataModel,
  SidebarDataModel,
} from './app-commons.model';
import { WeatherCalculateET0Request } from '@nutricontrol/app360-shared';

@Injectable({
  providedIn: 'root',
})
export class AppCommonsService {
  constructor(private restApiService: RestApiService) {}

  public putMenu(data): Observable<SidebarDataModel> {
    return this.restApiService.putMenu(data);
  }

  public getLayout(): Observable<LayoutDataModel> {
    return this.restApiService.getLayout();
  }

  public getLanguages(): Observable<LanguagesDataModel> {
    return new Observable((observer) => {
      this.restApiService.getLanguages().subscribe(
        (response) => {
          observer.next(response);
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  public calculateET0ByTerminalVid(
    terminalVid: string,
    calculateET0Request: WeatherCalculateET0Request
  ): Observable<ET0Model> {
    return new Observable((observer) => {
      this.restApiService
        .calculateEquipmentET0(terminalVid, calculateET0Request)
        .subscribe(
          (response) => {
            observer.next(response);
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  public calculateET0ForecastByTerminalVid(
    terminalVid: string,
    calculateET0Request: WeatherCalculateET0Request
  ): Observable<ET0Model> {
    return new Observable((observer) => {
      this.restApiService
        .calculateEquipmentET0Forecast(terminalVid, calculateET0Request)
        .subscribe(
          (response) => {
            observer.next(response);
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }
}
